var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import styled from 'styled-components';
import { SAIconAddContact, SAIconAdjuster, SAIconAlert, SAIconArrowRight, SAIconAuto, SAIconBank, SAIconBilling, SAIconCalculate, SAIconChecklist, SAIconChevronDown, SAIconChevronDownBold, SAIconChevronLeft, SAIconChevronLeftBold, SAIconChevronRight, SAIconChevronRightBold, SAIconChevronUp, SAIconChevronUpBold, SAIconChevronsDown, SAIconChevronsLeft, SAIconChevronsRight, SAIconChevronsUp, SAIconClaim, SAIconClock, SAIconDocumentPDF, SAIconDocument, SAIconDownload, SAIconError, SAIconEye, SAIconFilter, SAIconGlassDamage, SAIconHelp, SAIconHome, SAIconIdCard, SAIconInfo, SAIconInformation, SAIconInjury, SAIconMedicalSuitcase, SAIconMenuKabob, SAIconMenuProfile, SAIconMore, SAIconPencil, SAIconPersonCircle, SAIconPersonHeadset, SAIconPawPrint, SAIconPin, SAIconRefresh, SAIconRoadsideAssistance, SAIconSearch, SAIconShield, SAIconSuccess, SAIconUmbrella, SAIconWarning, SAIconX, SAIconCheckmark, SAIconTrash, } from './icons';
// TODO: Figure out how to cleanly type this (remove any type).
var IconMap = {
    addContact: SAIconAddContact,
    adjuster: SAIconAdjuster,
    alert: SAIconAlert,
    arrowRight: SAIconArrowRight,
    auto: SAIconAuto,
    bank: SAIconBank,
    billing: SAIconBilling,
    calculate: SAIconCalculate,
    checklist: SAIconChecklist,
    checkmark: SAIconCheckmark,
    chevronDown: SAIconChevronDown,
    chevronDownBold: SAIconChevronDownBold,
    chevronLeft: SAIconChevronLeft,
    chevronLeftBold: SAIconChevronLeftBold,
    chevronRight: SAIconChevronRight,
    chevronRightBold: SAIconChevronRightBold,
    chevronUp: SAIconChevronUp,
    chevronUpBold: SAIconChevronUpBold,
    chevronsDown: SAIconChevronsDown,
    chevronsLeft: SAIconChevronsLeft,
    chevronsRight: SAIconChevronsRight,
    chevronsUp: SAIconChevronsUp,
    claim: SAIconClaim,
    clock: SAIconClock,
    documentPDF: SAIconDocumentPDF,
    document: SAIconDocument,
    download: SAIconDownload,
    error: SAIconError,
    eye: SAIconEye,
    filter: SAIconFilter,
    glassDamage: SAIconGlassDamage,
    help: SAIconHelp,
    home: SAIconHome,
    idCard: SAIconIdCard,
    info: SAIconInfo,
    information: SAIconInformation,
    injury: SAIconInjury,
    medicalSuitcase: SAIconMedicalSuitcase,
    menuKabob: SAIconMenuKabob,
    menuProfile: SAIconMenuProfile,
    more: SAIconMore,
    pawPrint: SAIconPawPrint,
    pencil: SAIconPencil,
    personCircle: SAIconPersonCircle,
    personHeadset: SAIconPersonHeadset,
    pin: SAIconPin,
    refresh: SAIconRefresh,
    roadsideAssistance: SAIconRoadsideAssistance,
    search: SAIconSearch,
    success: SAIconSuccess,
    shield: SAIconShield,
    trash: SAIconTrash,
    umbrella: SAIconUmbrella,
    warning: SAIconWarning,
    x: SAIconX,
};
var ButtonReset = styled.button(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  background: none;\n  color: inherit;\n  border: none;\n  padding: 0;\n  font: inherit;\n  cursor: pointer;\n  outline: inherit;\n  &:disabled {\n    cursor: not-allowed;\n  }\n"], ["\n  background: none;\n  color: inherit;\n  border: none;\n  padding: 0;\n  font: inherit;\n  cursor: pointer;\n  outline: inherit;\n  &:disabled {\n    cursor: not-allowed;\n  }\n"])));
export function SAIcon(props) {
    var icon = props.icon, onClick = props.onClick;
    var IconComponent = icon ? IconMap[icon] : IconMap.auto;
    if (onClick) {
        return (React.createElement(ButtonReset, { type: "button", onClick: onClick },
            React.createElement(IconComponent, __assign({}, props))));
    }
    return React.createElement(IconComponent, __assign({}, props));
}
var templateObject_1;
//# sourceMappingURL=icon.component.js.map